var SettingCashMovement = /** @class */ (function () {
    function SettingCashMovement(props) {
        Object.assign(this, props);
        this.disabled_at = props.disabled_at ? new Date(props.disabled_at) : null;
    }
    return SettingCashMovement;
}());
export var TypeMovement = {
    In: 'in',
    Out: 'out'
};
export default SettingCashMovement;



//////////////////
// WEBPACK FOOTER
// ./src/modules/SettingCashMovements/Model.ts
// module id = 206
// module chunks = 0